export default "__VITE_ASSET__DNJS2wyn__"